import { api } from './client';

export interface TrackDTO {
  name: string;      // display name (no extension)
  fileName: string;  // storage file name (with extension) — used for delete
  url: string;       // signed URL
}

export const musicApi = {
  // Shared library of uploaded tracks. Goes through the api client (user JWT).
  async list(): Promise<TrackDTO[]> {
    const res = await api.get<{ tracks: TrackDTO[] }>('/music');
    return res.tracks || [];
  },

  // Upload mp3/m4a/aac to the shared bucket. Returns the new track.
  async upload(file: File): Promise<TrackDTO> {
    const form = new FormData();
    form.append('file', file);
    return api.postFormData<TrackDTO>('/music/upload', form);
  },

  // Remove a track from the shared library by its storage file name.
  async remove(fileName: string): Promise<void> {
    await api.delete(`/music/${encodeURIComponent(fileName)}`);
  },
};
